import { useGetOntology } from "core/model/utils/ontologies/hooks";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { EmptiableField } from "dsl/organisms/PatientProfileDetailsShared/shared";
import {
  grantLabelMaker,
  GrantValue,
  isGrantChecked,
} from "dsl/static/StaticGrantStatusField";
import { useTranslations } from "translations";

export function GrantStatusField({
  hasNotApplied,
  label,
  testId,
  value,
}: {
  hasNotApplied?: boolean;
  label: string;
  testId: string;
  value: GrantValue | null | undefined;
}) {
  const getOntology = useGetOntology();
  const isChecked = isGrantChecked(value);
  const translations = useTranslations();

  const newLabel = grantLabelMaker(
    label,
    value,
    getOntology,
    translations,
    hasNotApplied,
  );

  return isChecked ? (
    <VerticalLayout margin={margin(0)}>
      <EmptiableField testId={testId} value={newLabel} />
    </VerticalLayout>
  ) : null;
}
